import * as React from 'react';

import '../Main.scss';
import '../ImportCustomerFinancials/NewConnectionModal.scss';
import './DestinationStep.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@awesome.me/kit-8a0d2fd588/icons/modules/classic/light';

import { PASSWORD_MANAGER_OPT_OUT } from '../design-system/components/Input';

type DisabledSearchBoxProps = {
    placeholder: string;
    // Resolved CommonText (fieldGuideSearchComingSoon); callers supply the English fallback.
    hoverText: string;
};

/**
 * The POC's search input, shown disabled until search is built (story #41109).
 *
 * The design system gives .cr-input--disabled pointer-events: none and opacity 0.24, so neither the hover handlers nor
 * the tooltip may live on or inside it. An outer, focusable host owns the hover/focus handlers; the disabled box and
 * the .page-tooltip bubble are siblings inside it, so the bubble renders at full opacity. The bubble is always in the
 * DOM (hidden until shown) so aria-describedby always resolves.
 */
export const DisabledSearchBox: React.FC<DisabledSearchBoxProps> = ({ placeholder, hoverText }): React.ReactElement => {
    const tooltipId = `${React.useId()}-tooltip`;
    const [showTooltip, setShowTooltip] = React.useState<boolean>(false);

    return (
        <span
            className={'page-search-host'}
            tabIndex={0}
            aria-describedby={tooltipId}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onFocus={() => setShowTooltip(true)}
            onBlur={() => setShowTooltip(false)}
        >
            <span className={'cr-input cr-input--disabled page-search-input'}>
                <span className={'cr-input__icon'}><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                <input className={'cr-input__control'} type={'search'} {...PASSWORD_MANAGER_OPT_OUT} disabled placeholder={placeholder} aria-label={placeholder} />
            </span>
            <span id={tooltipId} role={'tooltip'} className={'page-tooltip page-tooltip--below'} hidden={!showTooltip}>
                {hoverText}
                <span className={'page-tooltip__arrow'} />
            </span>
        </span>
    );
};
